import { cart, userErrors } from '../objects/cart'
// https://shopify.dev/docs/api/storefront/2023-10/mutations/cartCreate
export const cartCreate = `
mutation cartCreate($input: CartInput!) {
  cartCreate(input: $input) {
    cart ${cart}
    userErrors ${userErrors}
  }
}`
